/**
 * home模块接口
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const home = {
	getHomeData(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/home`,
			data: qs.stringify(data)
		});
	}
};

export default home;
